/**************************************
 ChangeLog:
 Date.       Modifier   Description
 2020-05-14  wangquan  axios封装对象
 **************************************/
import axios from 'axios'
import { Message } from 'element-ui'
import router from "../../router";

// 创建一个 axios 实例
const service = axios.create({
  baseURL: window.config.domain,
  // withCredentials: true,
  timeout: 10000 // 请求超时时间
})

//请求拦截器
service.interceptors.request.use(
  config => {
    //在发送请求之前做某事
    config.headers.PATHURL = router.currentRoute.path;
    config.headers.PATHNAME = encodeURI(router.currentRoute.name);
    if(config.url != '/login' && config.url != '/logout' && config.url != '/loginNoCaptcha'
    && config.url.indexOf('/column/getAll')>-1 && config.url.indexOf('/yqlj')>-1 && config.url.indexOf('/zhzy')>-1
    && config.url.indexOf('/util/currentDate')>-1&& config.url.indexOf('/mhZDlist')>-1&& config.url.indexOf('/mhpage')>-1&& config.url.indexOf('/mhlist')>-1
    && config.url.indexOf('/doSearchGjAndFj')>-1&& config.url.indexOf('/ranking')>-1&& config.url.indexOf('/doSearchVOList')>-1&& config.url.indexOf('/updateByVO')>-1
    && config.url.indexOf('support/log/visit')&& config.url.indexOf('/doSeachlist')&& config.url.indexOf('/doSearchListByRank')
    && config.url.indexOf('/getJlnd') && config.url.indexOf('/mhFindByVO')){
      var isLogin = localStorage.getItem('isLogin');
      if(isLogin != 'TRUE'){
        router.push({path: '/'});
      }
    }
    /**采用TOKEN验证方式  by li.xue */
    var token = localStorage.getItem("XTOKEN");
    if (token != null){
      config.headers.XTOKEN = token;
    }
    return config;
  },
  error => {
    // 发送失败
    console.log(error)
    return Promise.reject(error)
  }
)

//响应拦截器
service.interceptors.response.use(
  response => {
    //展示请求错误信息
    //错误提示键值对
    let code = response.data.code;
    if (code == '00000000') {
      return response;
    } else {
      if (code == '44444444') {
        localStorage.clear();
        // Message.error('登录超时，请重新登录');
        router.push({name: 'index', query: {type: "44444444"}});
      } else if (code == '55555555'){
        localStorage.clear();
        // Message.error('登录失效，请重新登录');
        router.push({name: 'index', query: {type: "55555555"}});
      } else {
        return response;
      }
    }
  },
  error => {
    //请求超时跳转到登录页面
    if("Network Error" == error.message){
      localStorage.clear();
      router.push({name: 'index'});
    }
    if(error.message.includes('timeout')){
      Message.error({
        showClose: true,
        message: "请求超时，请稍后再试",
        type: 'error'
      });
    }else{
      Message.error({
        showClose: true,
        message: "error",
        type: 'error'
      });
    }
    return Promise.reject(error);
  }
)

export default service



// WEBPACK FOOTER //
// ./src/plugin/axios/index.js